import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const StatusIcon = ({ fill = '#F6A609', width = 20, height = 20 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.9974" cy="10.0003" r="3.33333" fill={fill} />
  </svg>
);
